import { queryClient } from '@/client/components/admin/Provider';
import { DATA_SCOPES, useDataScopeStore } from '@/client/stores/data-scope';

/** Header segmented control: which data every admin page shows (live / test / all). */
export function DataScopeSwitch() {
  const { scope, setScope } = useDataScopeStore();

  return (
    <div role="radiogroup" aria-label="Data shown" className="flex rounded-lg border border-gray-200 bg-white p-0.5 text-sm">
      {DATA_SCOPES.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          role="radio"
          aria-checked={scope === key}
          onClick={() => {
            if (key === scope) return;
            setScope(key);
            // Query keys don't carry the scope, so drop every cached result.
            queryClient.resetQueries();
          }}
          className={`rounded-md px-3 py-1 font-medium transition-colors ${
            scope === key
              ? key === 'test'
                ? 'bg-amber-100 text-amber-800'
                : 'bg-gray-900 text-white'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
